import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Chip,
    TextField,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import ModalEditarServico from "./ModalEditarServico";
import HomeIcon from '@mui/icons-material/Home';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Breadcrumbs, Link } from "@mui/material";
import ModalExcluirServico from "./ModalExcluirServico";

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const cabecalhoSx = { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, color: "#6b7280", textTransform: "uppercase", borderBottom: "none", py: 1 };
const celulaSx = { fontSize: 13, color: "#374151", borderBottom: "1px solid #f3f4f6", py: 1.25 };

const Servicos = () => {
    const { user } = useUser();
    const navigate = useNavigate();

    const [busca, setBusca] = useState("");
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [openModalEditarServico, setOpenModalEditarServico] = useState(false);
    const [openModalExcluirServico, setOpenModalExcluirServico] = useState(false);
    const [servicos, setServicos] = useState([])
    // eslint-disable-next-line no-unused-vars
    const [idServico, setIdServico] = useState(null);

    useEffect(() => {
        // Verifica se o usuário está com servico vencida
        const hasservicosVencidas = user?.servicos?.vencidas?.length > 0;

        if (hasservicosVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])

    useEffect(() => {
        const getServicos = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarServicos`, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });
            if (response.data.status === 200) {
                setServicos(response.data.servicos);
            }
        }

        getServicos();

    }, [openModalEditarServico, openModalExcluirServico])

    // Filtra na renderização para a busca continuar valendo quando a lista é recarregada
    const termoBusca = busca.trim().toLowerCase();
    const servicosFiltrados = termoBusca
        ? servicos.filter((servico) =>
            String(servico.discriminacao ?? "").toLowerCase().includes(termoBusca) ||
            String(servico.codigo ?? "").toLowerCase().includes(termoBusca)
        )
        : servicos;

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <DesignServicesIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Meus Serviços
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Meus Serviços
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Serviços cadastrados para a sua empresa, usados na emissão das suas notas fiscais.
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate("../Dashboard")}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                        >
                            Voltar
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={() => navigate("../Dashboard/EmitirNotaServico")}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", boxShadow: "none", px: 2, "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" } }}
                        >
                            Emitir NFS-e
                        </Button>
                    </Box>
                </Box>

                <Box sx={{ ...cardSx, mt: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, flexWrap: "wrap", mb: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Box sx={{ width: 36, height: 36, borderRadius: "8px", backgroundColor: "#f3f4f6", color: "#374151", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <MedicalServicesOutlinedIcon sx={{ fontSize: 20 }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>Serviços cadastrados</Typography>
                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                    {servicos.length} {servicos.length === 1 ? "serviço" : "serviços"} no total
                                </Typography>
                            </Box>
                        </Box>
                        <TextField
                            placeholder="Buscar por código ou discriminação"
                            size="small"
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                            sx={{ width: { xs: "100%", sm: 320 }, "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff", fontSize: 13 } }}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search sx={{ fontSize: 18, color: "#6b7280" }} />
                                        </InputAdornment>
                                    )
                                }
                            }}
                        />
                    </Box>

                    <TableContainer sx={{ overflowX: "auto" }}>
                        <Table sx={{ minWidth: 560 }}>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f3f4f6", "& th:first-of-type": { borderRadius: "6px 0 0 6px" }, "& th:last-of-type": { borderRadius: "0 6px 6px 0" } }}>
                                    <TableCell sx={{ ...cabecalhoSx, width: 140 }}>Código</TableCell>
                                    <TableCell sx={cabecalhoSx}>Discriminação</TableCell>
                                    <TableCell sx={{ ...cabecalhoSx, width: 80 }} align="right">ID</TableCell>
                                    {/* <TableCell sx={cabecalhoSx} align="center">Ações</TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {servicosFiltrados.length > 0 ? (
                                    servicosFiltrados.map((servico) => (
                                        <TableRow key={servico.idServico} hover>
                                            <TableCell sx={celulaSx}>
                                                <Chip label={servico.codigo} size="small" sx={{ backgroundColor: "#0b243d", color: "#ffc845", fontWeight: 700, fontSize: 11, height: 22, borderRadius: "6px" }} />
                                            </TableCell>
                                            <TableCell sx={{ ...celulaSx, color: "#111827", fontWeight: 500 }}>{servico.discriminacao}</TableCell>
                                            <TableCell sx={{ ...celulaSx, color: "#9ca3af", fontSize: 12 }} align="right">#{servico.idServico}</TableCell>
                                            {/* Ações desativadas — para reativar, use setIdServico(servico.idServico) e abra
                                                setOpenModalEditarServico(true) ou setOpenModalExcluirServico(true) */}
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center" sx={{ borderBottom: "none", py: 6 }}>
                                            <MedicalServicesOutlinedIcon sx={{ fontSize: 36, color: "#d1d5db" }} />
                                            <Typography sx={{ mt: 1, fontSize: 14, fontWeight: 600, color: "#374151" }}>
                                                Nenhum serviço encontrado.
                                            </Typography>
                                            <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                                {servicos.length > 0 ? "Tente buscar por outro código ou descrição." : "Ainda não há serviços cadastrados para a sua empresa."}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{ mt: 2, backgroundColor: "#f3f4f6", borderRadius: "8px", px: 1.5, py: 1 }}>
                        <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                            Exibindo <Box component="span" sx={{ color: "#111827", fontWeight: 700 }}>{servicosFiltrados.length}</Box> de {servicos.length} serviços
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <ModalEditarServico
                openModalEditarServico={openModalEditarServico}
                setOpenModalEditarServico={setOpenModalEditarServico}
                idServico={idServico}
            />
            <ModalExcluirServico
                openModalExcluirServico={openModalExcluirServico}
                setOpenModalExcluirServico={setOpenModalExcluirServico}
                idServico={idServico}
            />
        </>
    );
};

export default Servicos;
